import { parse as parseCookies } from 'cookie';

export const getCookie = (cookie: string) => {
  // eslint-disable-next-line
  if (globalThis?.document?.cookie) {
    // eslint-disable-next-line
    return parseCookies(globalThis.document.cookie)?.[cookie];
  }
};

export const setCookie = (cookie: string, val: string | number, age = 365) => { // age в днях
  // eslint-disable-next-line
  globalThis.document.cookie = `${cookie}=${val};path=/;max-age=${age*24*60*60};`;
};

export const setCookieRaw = (cookie: string, val: string, age = 1000) => { // age в секундах
  // eslint-disable-next-line
  globalThis.document.cookie = `${cookie}=${val};path=/;max-age=${age};`;
};

export const removeCookie = (cookie: string) => {
  // eslint-disable-next-line
  globalThis.document.cookie = `${cookie}=;path=/;max-age=0;`;
};
